









































import '@/components/input/input-main.css';
import { Vue, Component, Prop, Model, Ref } from 'vue-property-decorator';
import Inputmask from 'inputmask';

import { Input } from '@/lib/formFactory/input';

@Component({
    name: 'InputBase',
})
export default class InputMain extends Vue {
    @Model('input', { type: [String, Number], required: true }) value!: string | number | null;
    @Prop({ required: true }) data!: Input;
    @Prop({ default: () => '' }) readonly error!: string;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) readonly!: boolean;
    @Prop({ default: false }) hidden!: boolean;

    @Ref() $input!: HTMLInputElement;

    isLabelActive = false;
    classes = {
        in: 'cd-label-active',
    };

    get isErrors() {
        return this.error.length > 0;
    }

    addClassIn() {
        this.isLabelActive = true;
    }

    removeClassIn() {
        this.isLabelActive = false;
    }

    updateValue() {
        const value = (this.data.mask) ?
            this.$input.inputmask?.unmaskedvalue() :
            this.$input.value;

        this.$emit('input', value);
    }

    mounted () {
        if (this.data.mask && Object.keys(this.data.mask || {}).length) {
            const inputmask = new Inputmask(this.data.mask);
            inputmask.mask(this.$input);

            this.$once('hook:beforeDestroy', () => {
                inputmask.remove();
            })
        }
    }
}
